export default __webpack_public_path__ + "static/espaco-gourmet-50e5e1dc5aaa0df655d49f86b3fea04a.jpg";